import { useMemo } from "react";
import { BlockEditor } from "./BlockEditor";
import { Doc as YDoc } from 'yjs'
import { useOrder } from "@/contexts/OrderContext";
import HtmlDiff from 'htmldiff-js';

export default function Tiptap({ contentKey, onContentChange, readOnly, enableBold = true }) {
    const ydoc = useMemo(() => new YDoc(), [])
    const { compareOrder, order } = useOrder()

    const content = useMemo(() => order.sections[contentKey], [order.sections, contentKey])
    const contentGenerated = useMemo(() => order.sections_generated[contentKey], [])

    if (compareOrder) {
        return <div className="ProseMirror" style={{ padding: '16px 42px' }} dangerouslySetInnerHTML={{ __html: HtmlDiff.execute(contentGenerated, content) }} />
    }

    return <BlockEditor enableBold={enableBold} readOnly={readOnly} hasCollab={false} ydoc={ydoc} content={content} onContentChange={onContentChange} />
}